import React from 'react';
import { Badge } from '../ui/badge';
import { Switch } from '../ui/switch';
import { Textarea } from '../ui/textarea';
import { Shield, Check, Clock } from 'lucide-react';

export const TopicsStep = ({ options, selectedTopics, onToggle }) => (
  <div className="space-y-3" data-testid="deep-step-topics">
    <p className="text-sm font-medium text-slate-700">What would you like help with?</p>
    <p className="text-xs text-slate-400">Select all that apply</p>
    <div className="space-y-2">
      {options.help_topics.map(topic => (
        <button key={topic} onClick={() => onToggle(topic)}
          className={`w-full text-left px-3 py-2.5 rounded-lg border text-sm transition-colors
            ${selectedTopics.includes(topic) ? 'bg-emerald-50 border-emerald-400 text-emerald-800' : 'border-slate-200 hover:border-emerald-300 text-slate-600'}`}
          data-testid={`topic-${topic.replace(/\s+/g, '-').toLowerCase()}`}>
          <div className="flex items-center gap-2">
            <div className={`w-4 h-4 rounded border flex items-center justify-center
              ${selectedTopics.includes(topic) ? 'bg-emerald-600 border-emerald-600' : 'border-slate-300'}`}>
              {selectedTopics.includes(topic) && <Check className="w-3 h-3 text-white" />}
            </div>
            {topic}
          </div>
        </button>
      ))}
    </div>
  </div>
);

export const AssetsStep = ({ options, selectedAssets, onToggle, description, setDescription }) => (
  <div className="space-y-3" data-testid="deep-step-assets">
    <p className="text-sm font-medium text-slate-700">What type of assets are you adding?</p>
    <p className="text-xs text-slate-400">Select all that apply</p>
    <div className="grid grid-cols-2 gap-2">
      {options.asset_types.map(asset => (
        <button key={asset} onClick={() => onToggle(asset)}
          className={`text-left px-3 py-2 rounded-lg border text-xs transition-colors
            ${selectedAssets.includes(asset) ? 'bg-emerald-50 border-emerald-400 text-emerald-800' : 'border-slate-200 hover:border-emerald-300 text-slate-600'}`}
          data-testid={`asset-${asset.replace(/[\s/]+/g, '-').toLowerCase()}`}>
          <div className="flex items-center gap-2">
            <div className={`w-3.5 h-3.5 rounded border flex items-center justify-center shrink-0
              ${selectedAssets.includes(asset) ? 'bg-emerald-600 border-emerald-600' : 'border-slate-300'}`}>
              {selectedAssets.includes(asset) && <Check className="w-2.5 h-2.5 text-white" />}
            </div>
            {asset}
          </div>
        </button>
      ))}
    </div>
    <div className="mt-3">
      <label className="text-xs font-medium text-slate-600 block mb-1">Tell us more (optional)</label>
      <Textarea value={description} onChange={e => setDescription(e.target.value)}
        placeholder="Describe your specific needs or challenges..." rows={3} className="text-sm" data-testid="deep-description" />
    </div>
  </div>
);

export const ReviewStep = ({ selectedTopics, selectedAssets, description, maskedMode, setMaskedMode }) => (
  <div className="space-y-3" data-testid="deep-step-review">
    <div className="bg-slate-50 rounded-lg p-4 space-y-3">
      <div>
        <span className="text-xs text-slate-500 block mb-1">Help topics</span>
        <div className="flex flex-wrap gap-1.5">{selectedTopics.map(t => <Badge key={t} variant="secondary" className="text-xs">{t}</Badge>)}</div>
      </div>
      <div>
        <span className="text-xs text-slate-500 block mb-1">Asset types</span>
        <div className="flex flex-wrap gap-1.5">{selectedAssets.map(a => <Badge key={a} variant="secondary" className="text-xs">{a}</Badge>)}</div>
      </div>
      {description && <div><span className="text-xs text-slate-500 block mb-1">Details</span><p className="text-sm text-slate-700">{description}</p></div>}
      <div className="flex items-center justify-between pt-2 border-t">
        <div className="flex items-center gap-2"><Shield className="w-4 h-4 text-emerald-600" /><span className="text-sm">Privacy Masked Mode</span></div>
        <Switch checked={maskedMode} onCheckedChange={setMaskedMode} data-testid="deep-masked-toggle" />
      </div>
    </div>
    <div className="bg-emerald-50 border border-emerald-200 rounded-lg p-3">
      <div className="flex items-center gap-2"><Clock className="w-4 h-4 text-emerald-600" /><span className="text-sm font-medium text-emerald-800">60-minute private session</span></div>
      <p className="text-xs text-emerald-600 mt-1">Your request will be reviewed. Once accepted, you'll be invited to pick a date and time.</p>
    </div>
  </div>
);
